import React, { FC } from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'

const App: FC = () => {
  return (
    <NavigationLayout dataApp='artist-profile'>
      <Layout />
    </NavigationLayout>
  )
}

export default App
